// Hotel recommendations near the reception venue (Old City Harbour Cruise Terminal)
export const HOTELS = [
  {
    key: "hestia",
    name: "Hestia Hotel Europa",
    tag: { en: "Closest to the harbour", et: "Sadama lähedal" },
    distance: { en: "~400 m · 5 min walk", et: "~400 m · 5 min jalutuskäik" },
    price: "€€",
    note: {
      en: "Modern rooms and a rooftop terrace — practically next door to the terminal.",
      et: "Kaasaegsed toad ja katuseterrass — praktiliselt terminali kõrval.",
    },
    href: "https://www.hestiahotels.com/europa/",
  },
  {
    key: "tallink-spa",
    name: "Tallink Spa & Conference Hotel",
    tag: { en: "Best for a spa stay", et: "Parim spaapuhkuseks" },
    distance: { en: "~500 m · 6–8 min walk", et: "~500 m · 6–8 min jalutuskäik" },
    price: "€€€",
    note: {
      en: "The biggest hotel near the port — pool, spa and a great buffet breakfast.",
      et: "Sadama lähim suur hotell — bassein, spaa ja rikkalik hommikusöök.",
    },
    href: "https://www.tallinkhotels.com/tallink-spa-conference-hotel",
  },
  {
    key: "hyatt",
    name: "Hyatt Place Tallinn",
    tag: { en: "Modern & central", et: "Kaasaegne ja keskne" },
    distance: { en: "~650 m · 8–10 min walk", et: "~650 m · 8–10 min jalutuskäik" },
    price: "€€€",
    note: {
      en: "Contemporary rooms steps from Old Town and the harbour — great views.",
      et: "Kaasaegsed toad vanalinna ja sadama vahel — kaunid vaated.",
    },
    href: "https://www.hyatt.com/hyatt-place/en-US/tllzt-hyatt-place-tallinn",
  },
  {
    key: "tallink-express",
    name: "Tallink Express Hotel",
    tag: { en: "Budget-friendly", et: "Soodne valik" },
    distance: { en: "~650 m · 8–10 min walk", et: "~650 m · 8–10 min jalutuskäik" },
    price: "€",
    note: {
      en: "Comfortable rooms in the same complex as Tallink Spa — great for the price.",
      et: "Mugavad toad Tallink Spa hoonekompleksis — hea hinna eest.",
    },
    href: "https://www.tallinkhotels.com/tallink-express-hotel",
  },
  {
    key: "citybox",
    name: "Citybox Tallinn",
    tag: { en: "Compact & modern", et: "Kompaktne ja moodne" },
    distance: { en: "~800 m · 10–12 min walk", et: "~800 m · 10–12 min jalutuskäik" },
    price: "€",
    note: {
      en: "Smart, self-check-in rooms — ideal if you just need a comfy place to sleep.",
      et: "Nutikad iseregistreerimisega toad — sobib täiuslikult, kui vajad lihtsalt mugavat ööbimist.",
    },
    href: "https://cityboxhotels.com/hotels/tallinn/",
  },
  {
    key: "hilton",
    name: "Hilton Tallinn Park",
    tag: { en: "The luxury pick", et: "Luksuslik valik" },
    distance: { en: "~1.8 km · 20 min walk", et: "~1,8 km · 20 min jalutuskäik" },
    price: "€€€",
    note: {
      en: "5-star hotel beside Tallinn Park with a rooftop spa, indoor pool, casino and city-park views — the finest choice for a special stay.",
      et: "5-tärni hotell Tallinna pargi ääres — katusespaa, siseujula, kasiino ja pargi-vaade. Parim valik erilise ööbimise jaoks.",
    },
    href: "https://www.hilton.com/en/hotels/tllhihi-hilton-tallinn-park/",
  },
];
